import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintStandingIntruction = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocStandingIntruction = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            padding: "5px 0",
            textDecoration: "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>
            STANDING INSTRUCTION
            <br />
            <span style={{ fontWeight: "normal" }}>(Perintah Pemindahbukuan)</span>
          </div>
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Sehubungan dengan permohonan dana Subsidi bantuan Uang muka Kepada Kepala Satuan kerja Direktorat Jenderal Pembiayaan Perumahan Kementerian Pekerjaan Umum dan Perumahan Rakyat, maka saya yang bertandatangan dibawah ini :</div>
          </div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "120px" }}>Nama</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>Tempat/Tgl Lahir</td>
                <td>:</td>
                <td>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? "-"}
                </td>
              </tr>
              <tr>
                <td>Pekerjaan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td style={{ verticalAlign: "top" }}>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginTop: "20px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dengan ini memberikan kuasa kepada PT . Bank Tabungan Negara (Persero) Tbk. Kantor Cabang untuk melakukan pemindahanbukuan pencairan dana Subsidi Bantuan Uang Muka (SBUM) senilai Rp 4.000.000,- ( Empat Juta Rupiah ) untuk digunakan sebagai pengurang pokok kredit atau pembayaran kekurangan uang muka pembelian rumah sejahtera *), kepada:</div>

          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "220px" }}>Nama Pengembang</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{companyName ?? ""}</td>
              </tr>
              <tr>
                <td>No Rekening</td>
                <td>:</td>
                <td>{"00130.0130.000188.0"}</td>
              </tr>
              <tr>
                <td>Rekening Atas Nama</td>
                <td>:</td>
                <td>{"PT. HIKMAH ALAM SENTOSA"}</td>
              </tr>
              <tr>
                <td>BTN</td>
                <td>:</td>
                <td>{"(KC/KCP/KANKAS)"}</td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "15px" }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Demikian Standing Intruction ini di buat tanpa adanya paksaan dari pihak manapun.Akibat apapun yang Mungkin timbul dari pelaksanaan penyaluran dana oleh PT. Bank Tabungan Negara (Persero) Tbk, berdasarkan Standing Intruction ini adalah sepenuhnya menjadi tanggung jawab saya.</p>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Penerima Kuasa
                <br />
                <div style={{ textAlign: "start" }}>PT Bank Tabungan Negara (Persero), Tbk Kantor Depok</div>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                textAlign: "center",
                width: "170px",
              }}
            >
              <div>
                Bogor, ................................
                <br />
                Yang Membuat Standing Instruction
              </div>
              <div
                style={{
                  marginTop: "40px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ padding: "10px", width: "fit-content", border: "1px solid #000" }}>
                  Materai
                  <br />
                  10.000,-
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              fontWeight: "bold",
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              gap: "10px",
            }}
          >
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                RACHMAT SUPRIYADI.C.B
                <br />
                <span style={{ fontWeight: "normal" }}>Sub Branch Head</span>
              </div>
            </div>
            <div
              style={{
                marginTop: "25px",
                width: "170px",
                textAlign: "center",
              }}
            >
              <div>
                {item.sls_appl?.name ?? "-"} <br />
                <span style={{ fontWeight: "normal" }}>Pemohon</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
